<script lang="ts" setup>
import { computed, ref, getCurrentInstance } from 'vue';

const instance = getCurrentInstance();

defineOptions({
    name: 'field-numeric'
});

const props = withDefaults(defineProps<{
    label: string,
    modelValue: number,
    placeholder?: string,
    append?: string,
    naturals?: boolean,
    nullable?: boolean,
    step?: number,
    precision?: number,
    min?: number,
    max?: number
    invalidFeedback?: (value: number) => string;
}>(), {
    append: null,
    placeholder: null,
    naturals: false,
    nullable: false,
    step: 1,
    precision: 0,
    min: () => Number.MIN_SAFE_INTEGER + 1,
    max: () => Number.MAX_SAFE_INTEGER - 1,
    invalidFeedback: null,
});

const emit = defineEmits<{
    (e: 'update:modelValue', value: number): void;
}>();

const focused = ref(false);

const uid = computed(() => `form-field-${instance.uid}`);
const display = computed(() => props.modelValue != null ? props.modelValue.toFixed(props.precision) : null);

const rangeMin = computed(() => props.naturals ? Math.max(0, props.min) : props.min);
const rangeMax = computed(() => props.max);

const triggerInput = (value: number): void =>
{
    emit('update:modelValue', value);
};

const update = (e: any): void =>
{
    if (!focused.value)
    {
        if (e.target.value !== '' || props.nullable === false)
            triggerInput(parseFloat(e.target.value || 0));
        else
            triggerInput(null);

        instance?.proxy?.$forceUpdate();
    }
};

const focus = (e: any): void =>
{
    focused.value = true;
};

const blur = (e: any): void =>
{
    focused.value = false;
    update(e);
};
</script>

<template>
    <div class="form-group">
        <label :for="uid" v-if="label">{{ label }}</label>
        <ideo-input-group :append="append">
            <input type="number" :min="rangeMin" :max="rangeMax" :step="step" :id="uid" class="form-control" :placeholder="placeholder" :value="display" @input="update" @focus="focus" @blur="blur">
        </ideo-input-group>
        <small class="form-text text-danger" v-if="invalidFeedback && invalidFeedback(modelValue)">
            {{ $t(invalidFeedback(modelValue)) }}
        </small>
    </div>
</template>
